import { isIOS } from './platform';

export const VOLUME_CONTROL_HEIGHT = 44;

export function getPXDecreasedOnIOS(height: number) {
  return `${isIOS() ? height - VOLUME_CONTROL_HEIGHT : height}px`;
}
